
import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product.model';
import { Benefit } from '../../../models/benefit.model';
import { MatDialog } from '@angular/material';
import { DialogType, AlertService } from '../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { LinkBenefitModalComponent } from './link-benefit-modal/link-benefit-modal.component';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';

@Component({
    selector: 'product-detail',
    template: require('./product-detail.component.html'),
    styles: [require('./product-detail.component.css')],
    animations: [fadeInOut]
})
export class ProductDetailComponent {
    benefits: Benefit[];
    benefitsPriceTotal: number = 0;
    benefitsCostTotal: number = 0;
    productId: number;
    product: Product;
    vendorId: number;
    parentsLink = [];
    heading: string;
    writePlansPermission = Permission.writePlansPermission;
    constructor(private route: ActivatedRoute, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService, public accountService: AccountService) {
        this.route.params.subscribe(params => {
            this.productId = params['productId'];
            this.vendorId = params['vendorId'];
            this.getBenefits();
        });
    }

    getBenefits() {

        if (this.productId) {

            this.apiService.getProductById(this.productId).subscribe(r => {
                this.product = r;
                this.heading = this.product.productName + ' (' + this.product.productId + ')';
                this.parentsLink = [{ name: 'Plans', link: 'products' }];
            })
            this.apiService.getBenefitsByProductId(this.productId).subscribe(r => {
                this.benefits = r;
                this.caclBenefitsPriceAndCost();
            })
        }  
    }


    caclBenefitsPriceAndCost() {
        this.benefitsPriceTotal = 0;
        this.benefitsCostTotal = 0;
        _.each(this.benefits, b => {
            this.benefitsPriceTotal += b.price;
            this.benefitsCostTotal += b.cost;
        })
        this.benefitsPriceTotal = parseFloat(this.benefitsPriceTotal.toFixed(2));
        this.benefitsCostTotal = parseFloat(this.benefitsCostTotal.toFixed(2));
    }

    addBenefits() {
        let dialogRef = this.dialog.open(LinkBenefitModalComponent, {
            width: '600px',
            data: {
                productId: this.productId
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            if (r) {

                this.getBenefits();
            }
        })
    }

    deleteBenefitFromProduct(benefitId: number) {
        this.alertService.showDialog("Do you want to delete this Benefit ?", DialogType.confirm, val => {

            this.apiService.deleteBenefitFromProduct(benefitId, this.productId).subscribe(r => {
                this.getBenefits();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/products/product-detail/product-detail.component.ts